class VariantsTransition extends HTMLElement {
  constructor() {
    super();

    this.attachShadow({ mode: "open" });

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          pointer-events: none;
          z-index: 0;
          overflow: hidden;
        }
        
        /* Version SVG Wave (active) */
        .wave-container-svg {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          transform: translateX(-100%);
          display: none;
        }
        
        .wave-container-svg.visible {
          display: block;
        }
        
        .wave-container-svg.fade-out {
          transition: opacity 0.4s ease-out;
          opacity: 0;
        }
        
        /* Version Rectangle plein écran (désactivée) */
        .wave-container {
          position: absolute;
          width: 100%;
          height: 100%;
          transform: translateX(-100%);
          background: var(--wave-color-light, #feae5a);
          display: none;
        }
        
        .wave-container.visible {
          display: block;
        }
        
        .wave-container.animating,
        .wave-container-svg.animating {
          transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .wave-container.fade-out {
          transition: opacity 0.4s ease-out;
          opacity: 0;
        }
        
        
        .wave-container.sweep-through,
        .wave-container-svg.sweep-through {
          transform: translateX(0) !important;
        }
        
        .wave-container.sweep-out,
        .wave-container-svg.sweep-out {
          transform: translateX(100%) !important;
        }
      </style>
      
      <!-- Version avec grand rectangle + vague SVG -->
      <div class="wave-container-svg" id="waveContainerSvg">
        <!-- Grand rectangle de fond -->
        <div style="position: absolute; width: 100%; height: 100%; background: var(--wave-color, #ffa8d3);"></div>
        
        <!-- Vague SVG sur le bord droit -->
        <svg id="transitionWave" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
             x="0px" y="0px" width="160px" height="100%" viewBox="0 0 160 1440" preserveAspectRatio="none"
             xml:space="preserve" fill="var(--wave-color, #ffa8d3)" 
             style="display: block; position: absolute; height: 100vh; top: 0; transform: translateX(100%); right: 24px;">
          <path id="wave1" d="M0,1440l0-48c0-48,0-144,0-240c0-96,0-192,0-288c0-96,0-192,0-288c0-96,0-192,0-288S0,96,0,48L0,0l160,0
          l-21.3,48C117,96,75,192,69.3,288C64,384,96,480,112,576s16,192,0,288s-48,192-42.7,288c5.7,96,47.7,192,69.4,240l21.3,48H0z"></path>
        </svg>
      </div>
    `;

    this.waveContainer = this.shadowRoot.querySelector("#waveContainerSvg"); // Utiliser la version SVG
    this.isTransitioning = false;
    this.initVariantLinks();
    this.createLoadingBar();
  }

  connectedCallback() {
    this.initVariantLinks();
    this.applyInitialBackgroundColor();
    document.addEventListener("variantLinksUpdated", () =>
      this.initVariantLinks()
    );
  }

  applyInitialBackgroundColor() {
    // Find the active variant link or first one
    const activeLink = document.querySelector('.product-form__barz-item.active')
      || document.querySelector('.product-form__barz-item');

    if (activeLink) {
      const color = activeLink.dataset.variantColor;
      if (color) {
        const productSection = document.querySelector('.shopify-section:has([data-section-type="w-product-template"])');
        if (productSection && productSection.querySelector('[data-enable-bg="true"]')) {
          productSection.style.backgroundColor = color;
        }
      }
    }
  }

  initVariantLinks() {
    const variantLinks = document.querySelectorAll(".product-form__barz-item");

    variantLinks.forEach((link) => {
      // Remove old listeners to prevent duplicates
      link.replaceWith(link.cloneNode(true));
    });

    // Re-query after replacing
    document.querySelectorAll(".product-form__barz-item").forEach((link) => {
      link.addEventListener("click", (e) => this.handleVariantChange(e));
    });
  }

  async handleVariantChange(event) {
    event.preventDefault();

    if (this.isTransitioning) return;

    const link = event.currentTarget;
    const href = link.getAttribute("href");
    const color = link.dataset.variantColor || "#feae5a";
    const productId = link.dataset.productId;
    window.ShopifyAnalytics.meta.product.id = link.dataset.productId;
    console.log(window.ShopifyAnalytics.meta.product.id);

    if (!href) return;

    // Mark current as inactive and new as active
    document.querySelectorAll(".product-form__barz-item").forEach((item) => {
      item.classList.remove("active");
    });
    link.classList.add("active");

    // Add blur to current images immediately on click
    const currentImages = document.querySelectorAll('.product-media img');
    currentImages.forEach(img => {
      img.classList.add('blurred');
    });

    // Start loading bar
    this.startLoadingBar();

    this.isTransitioning = true;

    try {
      // Start wave animation and fetch simultaneously
      const wavePromise = this.startWaveAnimation(color);

      // Get all sections that might contain product data
      const sectionsToUpdate = this.getAllProductSections();

      // Fetch all sections in parallel
      const fetchPromises = sectionsToUpdate.map(async (sectionInfo) => {
        const response = await fetch(`${href}?section_id=${sectionInfo.id}`);
        if (!response.ok) throw new Error(`Failed to fetch section ${sectionInfo.id}`);
        const html = await response.text();
        return { ...sectionInfo, html };
      });

      // Wait for all fetches to complete
      const sectionsData = await Promise.all(fetchPromises);

      // Wait for wave to cover screen
      await wavePromise;

      // Replace content of all sections
      this.updateAllSections(sectionsData);

      // Setup fade-in for images in product-media
      this.setupImageFadeIn();

      // Reinitialize any necessary scripts
      this.reinitializeProductForm();

      // Update URL without reload
      window.history.pushState({}, "", href);

      // Complete loading bar
      this.completeLoadingBar();

      // Continue and complete wave animation
      await this.finishWaveAnimation();

    } catch (error) {
      console.error("Error changing variant:", error);
      // Complete loading bar even on error
      this.completeLoadingBar();
      // Fallback to regular navigation
      window.location.href = href;
    } finally {
      this.isTransitioning = false;
    }
  }

  async startWaveAnimation(color) {
    // Set the wave color for the SVG and rectangle
    this.style.setProperty("--wave-color", color);

    // Update background rectangle color
    const bgRect = this.waveContainer.querySelector('div');
    if (bgRect) {
      bgRect.style.background = color;
    }

    // Update SVG wave color
    const svgPath = this.waveContainer.querySelector('path');
    if (svgPath) {
      svgPath.setAttribute('fill', color);
    }

    // Reset by removing all classes first
    this.waveContainer.classList.remove("animating", "sweep-through", "sweep-out", "fade-out", "visible");

    // Reset inline styles
    this.waveContainer.style.transform = "";
    this.waveContainer.style.opacity = "";

    // Force reflow
    void this.waveContainer.offsetWidth;

    // Set initial position
    this.waveContainer.style.transform = "translateX(-100%)";

    // Show the container
    this.waveContainer.classList.add("visible");

    // Force another reflow
    void this.waveContainer.offsetWidth;

    // Add animation class
    this.waveContainer.classList.add("animating");

    // Small delay to ensure animation is ready
    await this.delay(10);

    // Trigger the sweep animation
    this.waveContainer.style.transform = "translateX(0)";

    // Wait for animation to complete
    await this.delay(600);
  }

  // Function to lighten a hex color
  lightenColor(color, amount = 0.4) {
    // Remove # if present
    color = color.replace("#", "");

    // Convert to RGB
    const num = parseInt(color, 16);
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;

    // Lighten each component towards white
    const newR = Math.round(r + (255 - r) * amount);
    const newG = Math.round(g + (255 - g) * amount);
    const newB = Math.round(b + (255 - b) * amount);

    // Convert back to hex with proper padding
    const toHex = (c) => c.toString(16).padStart(2, "0");
    return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
  }

  async finishWaveAnimation() {
    // Apply background color to product section first
    const productSection = document.querySelector('.shopify-section:has([data-section-type="w-product-template"])');
    if (productSection && productSection.querySelector('[data-enable-bg="true"]')) {
      const currentColor = this.style.getPropertyValue("--wave-color");
      productSection.style.backgroundColor = currentColor;
      productSection.style.transition = "background-color 0.4s ease-out";
    }

    // Wait for background color transition to complete
    await this.delay(400);

    // Continue sweep from 0% to 100% (exit screen)
    this.waveContainer.style.transform = "translateX(100%)";

    // Wait for exit animation
    await this.delay(600);

    // First hide the container
    this.waveContainer.classList.remove("visible");

    // Small delay to ensure it's hidden
    await this.delay(50);

    // Then reset everything while hidden
    this.waveContainer.classList.remove("animating", "sweep-through", "sweep-out", "fade-out");
    this.waveContainer.style.transform = "translateX(-100%)";
    this.waveContainer.style.opacity = "";
  }

  // Legacy methods for compatibility
  async triggerWaveAnimation(color) {
    await this.startWaveAnimation(color);
    await this.finishWaveAnimation();
  }

  async completeWaveAnimation() {
    // Not needed with new implementation
  }

  getAllProductSections() {
    const sections = [];

    // Get all sections with data-section-type attribute
    const sectionElements = document.querySelectorAll('[data-section-type]');

    sectionElements.forEach((sectionElement) => {
      const shopifySection = sectionElement.closest('.shopify-section');
      if (shopifySection) {
        const sectionId = shopifySection.getAttribute('id')?.replace('shopify-section-', '');
        const sectionType = sectionElement.getAttribute('data-section-type');

        // Exclude sidecart from product changes to prevent gift duplication
        if (sectionType === 'w-sidecart') {
          return;
        }

        if (sectionId) {
          sections.push({
            id: sectionId,
            type: sectionType,
            element: shopifySection
          });
        }
      }
    });

    return sections;
  }

  updateAllSections(sectionsData) {
    const parser = new DOMParser();

    sectionsData.forEach(({ element, html, type }) => {
      try {
        const doc = parser.parseFromString(html, 'text/html');

        // Find the corresponding section in the fetched HTML
        const newSection = doc.querySelector('.shopify-section');

        if (newSection && element) {
          // Special handling for product-template section
          if (type === 'w-product-template') {
            // Only replace product-form and SVG for product-template
            const newProductForm = newSection.querySelector('product-form');
            const currentProductForm = element.querySelector('product-form');
            const newProductSvg = newSection.querySelector('.product-template__svg');
            const currentProductSvg = element.querySelector('.product-template__svg');

            if (newProductForm && currentProductForm) {
              currentProductForm.innerHTML = newProductForm.innerHTML;
            }

            if (newProductSvg && currentProductSvg) {
              currentProductSvg.replaceWith(newProductSvg.cloneNode(true));
            }
          } else {
            // For other sections, replace the entire content
            element.innerHTML = newSection.innerHTML;
          }
        }
      } catch (error) {
        console.warn(`Failed to update section ${type}:`, error);
      }
    });
  }

  reinitializeProductForm() {
    // Reinitialize variant links
    this.initVariantLinks();

    // Reinitialize product template if it exists
    const productTemplate = document.querySelector("product-form");
    if (
      productTemplate &&
      typeof productTemplate.connectedCallback === "function"
    ) {
      productTemplate.connectedCallback();
    }

    // Reinitialize swiper if needed
    const swiperContainer = document.querySelector(".product-media__slider");
    if (swiperContainer && typeof Swiper !== "undefined") {
      new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 6,
        pagination: {
          el: ".product-media__slider .swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".product-media .swiper-next",
          prevEl: ".product-media .swiper-prev",
        },
      });
    }

    // Trigger custom event for all sections to reinitialize themselves
    document.dispatchEvent(new CustomEvent("variantChanged"));
  }

  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // Create loading bar element
  createLoadingBar() {
    if (!document.querySelector('.loading-bar')) {
      const loadingBar = document.createElement('div');
      loadingBar.className = 'loading-bar';
      document.body.appendChild(loadingBar);
      this.loadingBar = loadingBar;
    } else {
      this.loadingBar = document.querySelector('.loading-bar');
    }
  }

  // Start loading bar animation
  startLoadingBar() {
    if (!this.loadingBar) this.createLoadingBar();

    this.loadingBar.classList.add('active');
    this.loadingBar.style.width = '0%';

    // Simulate progressive loading
    setTimeout(() => this.loadingBar.style.width = '30%', 100);
    setTimeout(() => this.loadingBar.style.width = '60%', 300);
  }

  // Complete loading bar
  completeLoadingBar() {
    if (this.loadingBar) {
      this.loadingBar.classList.add('complete');

      // Hide after completion
      setTimeout(() => {
        this.loadingBar.classList.remove('active', 'complete');
        this.loadingBar.style.width = '0%';
      }, 500);
    }
  }

  // Setup fade-in effect for images in product-media
  setupImageFadeIn() {
    const productMediaImages = document.querySelectorAll(".product-media img");

    productMediaImages.forEach((img) => {
      // Force loading state (invisible) - even for cached images
      img.classList.add("loading");
      img.classList.remove("loaded", "blurred"); // Remove blur class when setting up new images

      // Setup load handler for new images
      const onLoad = () => {
        // Add a minimum delay to make the fade-in visible
        setTimeout(() => {
          img.classList.remove("loading");
          img.classList.add("loaded");
        }, 200);
        cleanup();
      };

      const onError = () => {
        setTimeout(() => {
          img.classList.remove("loading");
          img.classList.add("loaded");
        }, 200);
        cleanup();
      };

      const cleanup = () => {
        img.removeEventListener("load", onLoad);
        img.removeEventListener("error", onError);
        clearTimeout(timeout);
      };

      // For already loaded/cached images, still do fade-in
      if (img.complete && img.naturalHeight !== 0) {
        setTimeout(() => {
          img.classList.remove("loading");
          img.classList.add("loaded");
        }, 300); // Longer delay for cached images to see the effect
      } else {
        // Setup handlers for images that need to load
        img.addEventListener("load", onLoad);
        img.addEventListener("error", onError);

        // Fallback timeout
        const timeout = setTimeout(() => {
          img.classList.remove("loading");
          img.classList.add("loaded");
          cleanup();
        }, 2500);
      }
    });
  }

  // Legacy event handlers for compatibility
  handleBefore = (e) => {
    const { color } = e.detail || {};
    this.triggerWaveAnimation(color || "#feae5a");
  };

  handleLeave = (e) => {
    this.completeWaveAnimation();
  };

  handleAfter = (e) => {
    // Not needed with new implementation
  };
}

customElements.define("variants-transition", VariantsTransition);
